import {
  fetchMetaDataApi,
  fetchContainerListApi,
  downloadContainersApi,
  fetchShipmentListApi,
  downloadShipmentsApi,
} from 'src/api/summaryDashboard';
import { getLastSortedColumnValue } from '../utils/pagination';
import {
  META_DATA_LOADED,
  SUMMARY_DASHBOARD_SET_PAGINATION,
  SUMMARY_DASHBOARD_RESET_PAGINATION,
  SUMMARY_DASHBOARD_ENABLE_LOADING,
  SUMMARY_DASHBOARD_DISABLE_LOADING,
  SUMMARY_DASHBOARD_SET_FILTER,
  SUMMARY_DASHBOARD_UPDATE_DATA,
 } from './constants';

export const fetchMetadata = () => async (dispatch) => {
  const response = await fetchMetaDataApi();
  if (response.isSuccess) {
    dispatch({
      data: response.data,
      type: META_DATA_LOADED,
    });
    return {
      data: response.data,
      isSuccess: true,
    };
  }
  return {
    isSuccess: false,
    errorMessage: response.errorMessage,
  };
};

export const setFilter = params => async(dispatch, getState) => {
  dispatch({
    type : SUMMARY_DASHBOARD_SET_FILTER,
    data : params,
  });
};

export const setPagination = pageParams => async (dispatch) => {
  dispatch({
    data: pageParams,
    type: SUMMARY_DASHBOARD_SET_PAGINATION,
  });
  dispatch(fetchContainerList());
};
export const resetPagination = pageParams => async (dispatch) => {
  dispatch({
    type: SUMMARY_DASHBOARD_RESET_PAGINATION,
  });
  dispatch(fetchContainerList());
};

export const resetAndSetBatchSize = pageParams => async (dispatch) => {
  dispatch({
    type: SUMMARY_DASHBOARD_RESET_PAGINATION,
  });
  dispatch({
    data: pageParams,
    type: SUMMARY_DASHBOARD_SET_PAGINATION,
  });
  dispatch(fetchContainerList());
};

const getLastColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastConsignmentIdPrev;
    case 'next':
      return pagination.lastConsignmentIdNext;
    default:
      return null;
  }
};

function getAccessTypeFilter(selectedAccessTypes) {
  return (selectedAccessTypes || []).map((item) => {
    if (item === 'PUBLIC' || item === 'PRIVATE') {
      return { accessType : item };
    }
    return {
      accessType : 'TEAM',
      teamId : item,
    };
  });
}
export const fetchContainerList = () => async (dispatch, getState) => {
  dispatch({
    type: SUMMARY_DASHBOARD_ENABLE_LOADING,
  });
  const filters = getState().summaryDashboardReducer.appliedFilters;
  const pagination = getState().summaryDashboardReducer.pagination;
  const body = {
    ...(filters.selectedGraphFilters || {}),
  };
  body.timeFilter = filters.timeFilter;
  body.startDate = filters.startDate || undefined;
  body.endDate = filters.endDate || undefined;
  body.shippingLine = filters.shippingLineList;
  body.chartId = filters.chartId;
  body.customerList = filters.customerList;
  body.shipperIdList = filters.shipperIdList;
  body.vendorList = filters.vendorList;
  body.ffIdList = filters.ffIdList;
  body.supplierList = filters.suppliers || undefined;
  body.movementTypeList = filters.movementTypes || undefined;
  body.originPortList = filters.originPortList || undefined;
  body.destinationPortList = filters.destinationPortList || undefined;
  body.componentId = filters.componentId;
  body.currentPageNumber = pagination.currentPageNumber;
  body.resultsPerPage = Number(pagination.resultPerPage);
  body.isNextPresent = pagination.isNextPresent;
  body.nextOrPrev = pagination.nextOrPrev;
  body.lastSortedColumnValue = getLastSortedColumnValue(pagination);
  body.lastTrackingRequestId = getLastColumnId(pagination);
  body.accessTypeFilters = getAccessTypeFilter(filters.selectedAccessTypes);
  const response = filters.chartId === 'SHIPMENT_SUMMARY_COUNT' ? await fetchShipmentListApi(body) : await fetchContainerListApi(body);
  if (response.isSuccess) {
    dispatch({
      type: SUMMARY_DASHBOARD_UPDATE_DATA,
      data : response.data,
    });
  }
  dispatch({
    type: SUMMARY_DASHBOARD_DISABLE_LOADING,
  });
  return response;
};
export const downloadContainers = selectedGraphFilters =>
async (dispatch, getState) => {
  const filters = getState().summaryDashboardReducer.appliedFilters;
  const body = {
    ...(selectedGraphFilters || {}),
  };
  body.timeFilter = filters.timeFilter;
  body.startDate = filters.startDate || undefined;
  body.endDate = filters.endDate || undefined;
  body.shippingLine = filters.shippingLineList;
  body.chartId = filters.chartId;
  body.customerList = filters.customerList;
  body.shipperIdList = filters.shipperIdList;
  body.vendorList = filters.vendorList;
  body.ffIdList = filters.ffIdList;
  body.supplierList = filters.suppliers || undefined;
  body.movementTypeList = filters.movementTypes || undefined;
  body.originPortList = filters.originPortList || undefined;
  body.destinationPortList = filters.destinationPortList || undefined;
  body.componentId = filters.componentId;
  body.accessTypeFilters = getAccessTypeFilter(filters.selectedAccessTypes);
  const response = filters.chartId === 'SHIPMENT_SUMMARY_COUNT' ? downloadShipmentsApi(body) : await downloadContainersApi(body);
  return response;
};
